import styled from 'styled-components'
import variables, { device, colors } from 'Styled/variables'

export const SearchForm = styled.form`
  display: flex;
  flex-wrap: wrap;
`

export const SearchContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;

  @media (max-width: 576px) {
    flex-direction: column;
  }
`

export const CustomInputWrapper = styled.div`
  width: 100%;
`

export const SearchInput = styled.input`
  background: ${colors.white};
  height: 48px;
  border: 1px solid ${colors.greyStroke};
  border-radius: 8px;
  font-size: ${variables.fontSize14};
  line-height: 21px;
  outline: none;
  padding: 16px;
  width: 100%;
  margin-bottom: 8px;
  color: ${colors.mainText};
  transition: border 0.3s;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  &::placeholder {
    color: ${colors.greyTextWhiteBg};
  }

  &:focus {
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    color: ${colors.mainText};
  }
  &:-webkit-text-fill-color {
    color: ${colors.mainText} !important;
  }
  &:selected {
    color: ${colors.mainText} !important;
  }

  &:-webkit-autofill,
  -webkit-autofill:active,
  -webkit-autofill:focus,
  -webkit-autofill:hover {
    -webkit-text-fill-color: ${colors.mainText} !important;
    color: ${colors.mainText} !important;
  }
  @media (max-width: 576px) {
    border: none;
    padding: 0;
    margin: 0;
  }
`

export const SearchFormBtnBlock = styled.div`
  button {
    width: 160px;
  }
`

export const ErrorBlock = styled.div`
  display: flex;
  flex-direction: column;
  height: 48px;
  span {
    color: #ec5765;
    margin-bottom: 12px;

    @media ${device.mobileMin} {
      /* width: 288px; */
      margin-bottom: 0px;
    }
  }
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  align-self: flex-start;

  @media ${device.mobileMin} {
    // align-items: center;
    gap: 12px;
    flex-direction: column;
  }
`

export const HorizontalLine = styled.hr`
  margin: 0;
`

export const ModalSubHeaderWrapper = styled.div`
  margin-bottom: 16px;
  @media (max-width: 576px) {
    margin-bottom: 0;
  }
`
